import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';

export default class ApprovalConfigurationInstanceDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.approvalConfigurationInstanceId  = '';
		this.approvalConfigurationInstanceName = '';
		this.approverTypeId  = '';
		this.approverTypeName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.approverLevel = '';
		this.approverUserNameId  = '';
		this.approverUserNameFirstName = '';
		this.storedProcedureName = '';
		this.approvalType = '';
		this.configurationContent = '';
		this.isSendNotification = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			approvalConfigurationInstanceId : '0',
			approvalConfigurationInstanceName : '0',
			approverTypeId : '0',
			approverTypeName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			approverLevel : '0',
			approverUserNameId : '0',
			approverUserNameFirstName : '0',
			storedProcedureName : '0',
			approvalType : '0',
			configurationContent : '0',
			isSendNotification : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}